<div
  style="
    padding: 10px;
    width: 302px;
  "
>
  <div
    style="display: flex; flex-direction: row;"
  >
    <div>
      <h1>New Loan Type</h1>
    </div>
    <div style="margin-top: -12%;margin-left: 32%;cursor: pointer;">
      <h1>
        <i class="material-icons noselect" (click)="closeDialog()"> close </i>
      </h1>
    </div>
  </div>

  <div>
    <mat-form-field style="width: 80%;">
        <mat-select [(ngModel)]="selectedLoanType" name="loanType" placeholder="Loan Type">
            <mat-option value="Fixed Rate">Fixed Rate</mat-option>
            <mat-option value="Adjustable Rate">Adjustable Rate</mat-option>
            <mat-option value="Line of Credit">Line of Credit</mat-option>
            <mat-option value="Other Type">Other Type</mat-option>
          </mat-select>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field style="width: 80%;">
      <input
        matInput
        placeholder="Product Name"
        maxlength="50"
        [(ngModel)]="newProductName"
      />
    </mat-form-field>
  </div>
  <div>
    <mat-form-field style="width: 80%;">
      <input
        matInput
        placeholder="Core Value"
        maxlength="15"
        [(ngModel)]="newCoreValue"
      />
    </mat-form-field>
  </div>
  <div>
    
    <button
      mat-raised-button
      matTooltip="Add new loan type"
      matTooltipClass="toolTipStyle"
      color="accent"
      (click)="submitNewLoanType()"
      style="margin-left: 50px;
      float: right;
      margin-top: 6%;
      margin-right: 8%;"
    >
      Submit
    </button>
  </div>
</div>
